import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { PowerBIReportModel, IntSelectModel, ICPLPowerBIClient } from "./api/cplapi/CPLAPI";

export interface IPowerBIService {
  getReport(reportID: number): Promise<PowerBIReportModel>;
  getReportSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class PowerBIService implements IPowerBIService {
  @inject(SERVICE_TYPES.CPLPowerBIClient) cplPowerBIClient!: ICPLPowerBIClient;

  async getReport(reportID: number): Promise<PowerBIReportModel> {
    return await this.cplPowerBIClient.getReport(reportID);
  }

  async getReportSelectModels(): Promise<IntSelectModel[]> {
    return await this.cplPowerBIClient.getReportSelectModels();
  }
}
